import {
  request,
  setHeader,
  setBaseUrl,
} from '@akerolabs/akero-vue/src/utils/request'

/**
 * @returns {Object}
 * @description A simple wrapper to expose the request library as a
 * service in angular js.
 */
export default function requestWrapper() {
  return { request, setHeader, setBaseUrl }
}
